// store.js
import {create} from 'zustand';

// Création du store Zustand
const useGlobalStore = create((set) => ({
  cursorPopupText: '',
  cursorPopupActive: false,

  // Action pour mettre à jour cursorPopupText
  setCursorPopupText: (text) => set({ cursorPopupText: text }),

  // Action pour mettre à jour cursorPopupActive
  setCursorPopupActive: (active) => set({ cursorPopupActive: active }),
}));

export default useGlobalStore;
